/**
 * withOmnitechAp
 * HOC for wrapping the provided component with OrdersProvider
 */

import React from 'react'

import OmnitechAppProvider from './omnitech-app-provider'

export default function withOmnitechAp(WrappedComponent) {
  return function OmnitechAppProviderHOC(props) {
    return (
      <OmnitechAppProvider>
        <WrappedComponent {...props} />
      </OmnitechAppProvider>
    )
  }
}
